import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { to: "/", label: "Home", testId: "footer-link-home" },
  { to: "/about", label: "About Us", testId: "footer-link-about" },
  { to: "/services", label: "Services", testId: "footer-link-services" },
  { to: "/equipment", label: "Equipment & Fleet", testId: "footer-link-equipment" },
  { to: "/projects", label: "Projects", testId: "footer-link-projects" },
  { to: "/contact", label: "Contact", testId: "footer-link-contact" },
];

const SERVICE_LINKS = [
  { to: "/services#solar-ic", label: "Solar Plant I&C" },
  { to: "/services#bess", label: "BESS I&C" },
  { to: "/services#epc", label: "EPC / Balance of Plant" },
  { to: "/services#electrical", label: "Electrical Contracting" },
  { to: "/services#earthwork", label: "Earth Work & Piling" },
  { to: "/services#land", label: "Land Liaison" },
  { to: "/services#manpower", label: "Manpower & Material Supply" },
];

function FooterBrand() {
  return (
    <div>
      <img src="/brand/yaduraj-logo-white-mono.png" alt="Yaduraj Enterprises" style={{ width: 180, marginBottom: 14 }} />
      <p style={{ margin: "0 0 6px", color: "#fff", fontWeight: 600 }}>Powering a Sustainable Future</p>
      <p style={{ margin: 0, color: "rgba(255,255,255,0.78)", lineHeight: 1.55 }}>
        Asset-backed Solar &amp; BESS I&amp;C, EPC and electrical contracting — Rajasthan &amp; pan-India.
      </p>
    </div>
  );
}

function FooterLinkList({ heading, links }) {
  return (
    <div>
      <h4>{heading}</h4>
      <ul style={{ listStyle: "none", padding: 0, margin: 0, lineHeight: 2 }}>
        {links.map((l) => (
          <li key={l.to + l.label}>
            <Link to={l.to} {...(l.testId ? { "data-testid": l.testId } : {})}>{l.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

function FooterContact() {
  return (
    <div>
      <h4>Contact</h4>
      <p style={{ margin: "0 0 12px" }}>
        <strong style={{ color: "#fff" }}>Registered Office — Barmer, Rajasthan</strong><br />
        Khasra No. 2135/0039, Sheo, Barmer, Rajasthan
      </p>
      <p style={{ margin: "0 0 12px" }}>
        <strong style={{ color: "#fff" }}>Delhi NCR Office</strong><br />
        Flat No. 63, Plot No. 6, Saidulajab, New Delhi
      </p>
      <p style={{ margin: "0 0 6px" }}>
        <a href="tel:+917689912984">+91 76899 12984</a><br />
        <a href="tel:+917878759012">+91 78787 59012</a>
      </p>
      <p style={{ margin: 0 }}>
        <a href="mailto:yadurajenterprises9@gmail.com">yadurajenterprises9@gmail.com</a>
      </p>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="ye-footer" data-testid="site-footer">
      <div className="ye-container">
        <div className="ye-footer-grid">
          <FooterBrand />
          <FooterLinkList heading="Quick Links" links={QUICK_LINKS} />
          <FooterLinkList heading="Services" links={SERVICE_LINKS} />
          <FooterContact />
        </div>
        <div className="ye-footer-bottom">
          <span>© 2026 Yaduraj Enterprises. All rights reserved.</span>
          <span>GSTIN &amp; Electrical Contractor Licence details available on request.</span>
        </div>
      </div>
    </footer>
  );
}
